// extracted by mini-css-extract-plugin
export default {"cls1":"WinBackPing-cls1__9Y","cls2":"WinBackPing-cls2_TzL WinBackPing-cls1__9Y"};